// Central brand assets for MD Link Cotizador
export const MDLINK_LOGO =
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_quote-opus-pac/artifacts/9bkaenql_logomdlink.webp";

// Corporate palette (matches the MD Link cloud logo)
export const BRAND = {
    primary: "#1BA5D9", // cloud cyan
    primaryDeep: "#0E7DAB", // active/hover
    primaryDark: "#0A5F82", // deep text on light
    primarySoft: "#E1F4FB", // very light tint
    amber: "#F59E0B",
};
